import { render, staticRenderFns } from "./MonitorInfoView.vue?vue&type=template&id=67e60fbc&scoped=true"
import script from "./MonitorInfoView.vue?vue&type=script&lang=js"
export * from "./MonitorInfoView.vue?vue&type=script&lang=js"
import style0 from "./MonitorInfoView.vue?vue&type=style&index=0&id=67e60fbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e60fbc",
  null
  
)

export default component.exports